import React from 'react'

export default function GuestRow({game, pr, team, index, onChangeTeam, onChangeGuests}) {
  const authHold = pr.state == 'hold'

  return <tr className='guest'>
    <td className='col-xs-6 text-left player-name name'>
      <h5>{`${pr.name} + Guest ${index + 1}`}</h5>
    </td>

    <td className='col-xs-2 text-center player-name action'></td>

    <td className='col-xs-1 player-team'>
      <select className='player-team form-control' name='team' value={team} onChange={(e) => onChangeTeam(e.target.value)}>
        {
          _.times(game.teams_count + 1).map(i => {
            const value = i == 0 ? '-' : i
            return <option key={i} value={i}>{value}</option>
          })
        }
      </select>
    </td>

    <td className='col-xs-2 cost-edit-form-wrapper'>
      <h5><span className='cost'>$ 0.00</span></h5>
    </td>

    <td className='col-xs-1'><h5>-</h5></td>
    <td className='col-xs-1'><h5></h5></td>

    {!authHold && <td className='col-xs-1'>
      <a className='btn btn-danger' onClick={() => onChangeGuests({id: pr.id, guestsNumber: pr.guests_number - 1, team: team})}>
        <i className='fa fa-trash-o'></i>
      </a>
    </td>}
  </tr>
}
